export const UPDATE_HOME = 'UPDATE_HOME'



// WEBPACK FOOTER //
// ./src/store/home/mutation-types.js